const formValidator = (payload) => {
  let isValid = true;
  const obj = {
    type: 'error',
    message: '',
  };
  if (!payload.title) {
    obj.message = 'project title is required!';
    isValid = false;
  }
  if (!payload.date_from) {
    obj.message = 'project start date is required!';
    isValid = false;
  }
  if (isValid) {
    return 'valid';
  }
  return obj;
};

export default formValidator;
